import EnumClass, { build } from '../EnumClass';
import data, { CountryId, CountryData } from './data';
import * as Translations from './translations';

export class Country extends EnumClass<CountryId, CountryData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: COUNTRIES,
  getById: getCountryById,
  marshaller: CountryMarshaller,
  isId: isCountryId,
} = build<CountryId, CountryData, Country>('CountryEnum', data, Country);
